var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPizzaPartRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "pizza-part-icon",
    style: {
      borderRadius: "100%"
    },
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "pizza-part-icon__background",
    fill: "none",
    d: "M18 9a9 9 0 1 1-9-9 9 9 0 0 1 9 9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "pizza-part-icon__outer-ring",
    fill: "currentColor",
    d: "M9 16.79A7.79 7.79 0 0 0 16.18 12a7.79 7.79 0 0 0-1.67-8.54A7.81 7.81 0 0 0 6 1.82 7.78 7.78 0 0 0 1.21 9 7.79 7.79 0 0 0 6 16.18a7.67 7.67 0 0 0 3 .61M9 18a9 9 0 1 1 9-9 9 9 0 0 1-9 9Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "pizza-part-icon__inner-part",
    fill: "currentColor",
    transform: "rotate(180 9 9)",
    d: "M8.48,2.16a6.86,6.86,0,0,0,0,13.68V2.16Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPizzaPartRight);
export default __webpack_public_path__ + "static/media/pizza_part_right.7196614bbb2d2316d1cb9d7d28ee4044.svg";
export { ForwardRef as ReactComponent };